import Axios from '@/assets/js/AxiosPlugin'

// 充值记录
export const searchRechargeList = params => { return Axios.post('/api/Admin/Record/searchRechargeList', params) }

// 充值备注
export const setRechargeRemark = params => { return Axios.post('/api/Admin/Record/setRechargeRemark', params) }

// 充值统计
export const rechargeStatistics = params => { return Axios.post('/api/Admin/Statistics/recharge', params) }

// 退款
export const handleRefund = params => { return Axios.post('/api/Admin/Record/refund', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/RechargeRecordApp/apis/index.js